import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { trackPageView } from "@/lib/analytics";
import { Navbar } from "@/components/site/Navbar";
import { Footer } from "@/components/site/Footer";
import Home from "@/pages/Home";
import Solutions from "@/pages/Solutions";
import Brief from "@/pages/Brief";
import About from "@/pages/About";
import Investors from "@/pages/Investors";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import Explore from "@/pages/Explore";
import HowItWorks from "@/pages/HowItWorks";
import Intelligence from "@/pages/Intelligence";
import Platform from "@/pages/Platform";
import SolutionRole from "@/pages/SolutionRole";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

const AnalyticsTracker = () => {
  const { pathname, search } = useLocation();
  useEffect(() => { trackPageView(pathname + search); }, [pathname, search]);
  return null;
};

function Shell() {
  const { pathname } = useLocation();
  const bare = pathname === "/admin";

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);

  return (
    <>
      <ScrollToTop />
      <AnalyticsTracker />
      {!bare && <Navbar />}
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/intelligence" element={<Intelligence />} />
          <Route path="/platform" element={<Platform />} />
          <Route path="/solutions/:role" element={<SolutionRole />} />
          <Route path="/brief" element={<Brief />} />
          <Route path="/solutions" element={<Solutions />} />
          <Route path="/about" element={<About />} />
          <Route path="/investors" element={<Investors />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/explore" element={<Explore />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </main>
      {!bare && <Footer />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Shell />
        <Toaster position="bottom-right" theme="dark" />
      </BrowserRouter>
    </div>
  );
}

export default App;
